import React from 'react';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';

const Atras = () => {
  const navigate = useNavigate();

  return (
    <IconButton onClick={() => navigate(-1)} sx={{ color: "white" }}>
      <ArrowBackIcon />
    </IconButton>
  );
};

export default Atras;
